import React from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome,
  FiCreditCard,
  FiTrendingUp,
  FiFileText,
  FiActivity,
  FiFile,
  FiSmartphone,
  FiPieChart,
  FiUsers,
  FiHeadphones,
  FiServer,
  FiShield,
  FiLock,
  FiSettings,
} from "react-icons/fi";

const navSections = [
  {
    title: "Overview",
    links: [
      { to: "/", label: "Home", icon: FiHome, end: true },
      { to: "/bill-payments", label: "Bill Payments", icon: FiCreditCard },
      { to: "/analytics", label: "Analytics", icon: FiTrendingUp },
      { to: "/reports", label: "Reports", icon: FiFileText },
    ],
  },
  {
    title: "Payments",
    links: [
      { to: "/transactions-management", label: "Transactions", icon: FiActivity },
      { to: "/invoices", label: "Invoices", icon: FiFile },
      { to: "/wallet", label: "Wallet", icon: FiSmartphone },
      { to: "/billing&commission", label: "Billing", icon: FiPieChart },
    ],
  },
  {
    title: "Customers",
    links: [
      { to: "/user-management", label: "Users", icon: FiUsers },
      { to: "/customer-support", label: "Support", icon: FiHeadphones },
    ],
  },
  {
    title: "Operations",
    links: [
      { to: "/service-status", label: "Service Status", icon: FiServer },
      { to: "/audit-logs", label: "Audit Logs", icon: FiShield },
      { to: "/rbac", label: "RBAC", icon: FiLock },
      { to: "/settings", label: "Settings", icon: FiSettings },
    ],
  },
];

const Sidebar = ({ isOpen, onClose }) => (
  <>
    {isOpen && <div className="sidebar-overlay d-md-none" onClick={onClose} aria-hidden="true" />}
    <aside className={`billr-sidebar${isOpen ? " open" : ""}`}>
      <div className="billr-sidebar-brand">
        <h1>billr</h1>
        <p>India Bill Payments · Admin</p>
      </div>
      <nav className="billr-sidebar-nav">
        {navSections.map((section) => (
          <React.Fragment key={section.title}>
            <div className="billr-nav-section">{section.title}</div>
            {section.links.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) => `billr-nav-link${isActive ? " active" : ""}`}
                onClick={onClose}
              >
                <Icon />
                {label}
              </NavLink>
            ))}
          </React.Fragment>
        ))}
      </nav>
    </aside>
  </>
);

export default Sidebar;
